import { ContentType } from '@atlassian/conversation-assistant-store/controllers/preview-content/contentType';

import { AVP_DASHBOARD_CREATE_KEY } from './avp-actions';
import {
	CONFLUENCE_AIFC_DATABASE_CREATE_KEY,
	CONFLUENCE_AIFC_SLIDES_CREATE_KEY,
	CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY,
	isConfluencePageCreateAction,
} from './confluence-actions';

type GetContentTypeFromActionKeyOptions = {
	/**
	 * Which flavour of page a page-creating action is expected to produce. Defaults to `'live'`
	 * because CWR publishes pages as live docs unless the user picks a plain page in the finalize
	 * dialog — pass `null` to follow that selection.
	 */
	pageSubType?: 'live' | null;
};

/**
 * The content type a not-yet-published (draft) action is expected to produce, so its icon can be
 * rendered via the shared preview item icon config. The published counterpart is
 * `getContentTypeFromPublishedContent`, which resolves the real type once content exists.
 */
export const getContentTypeFromActionKey = (
	actionKey: string | undefined,
	{ pageSubType = 'live' }: GetContentTypeFromActionKeyOptions = {},
): ContentType | null => {
	if (!actionKey) {
		return null;
	}
	if (isConfluencePageCreateAction({ key: actionKey })) {
		return pageSubType === 'live' ? ContentType.liveDoc : ContentType.page;
	}
	switch (actionKey) {
		case CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY:
			return ContentType.whiteboard;
		case CONFLUENCE_AIFC_SLIDES_CREATE_KEY:
			return ContentType.slides;
		case CONFLUENCE_AIFC_DATABASE_CREATE_KEY:
			return ContentType.database;
		case AVP_DASHBOARD_CREATE_KEY:
			return ContentType.dashboard;
		default:
			return null;
	}
};
